import http from '../../../Utils/http';
const CheckoutPayment = {
  name: 'checkoutPayment',
  state: {
    loading: false,
    error: '',
    permissions: [
      'organization:view',
      'organization:create',
      'organization:delete',
      'organization:update',
    ],
    message:''
  },
  reducers: {
    checkoutPaymentRequested(state){
      return {
        ...state,
        loading: true,
        error: '',
        message:''
      };
    },
    checkoutPaymentReceived(state,payload){
      return {
        ...state,
        loading:false,
        message:payload,
        error:'',
      }
    },
    checkoutPaymentRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
        message:'',
        loading:false,
      };
    },

  },
  effects: (dispatch) => ({
   async requestForCheckoutPayment(data) {
        try {
          this.checkoutPaymentRequested();
          const response = await http.post(`savvy/users/checkout-payment`, data);
          this.checkoutPaymentReceived(response.data.session.url);
        } catch (err) {
          this.checkoutPaymentRequestFailed(err.response.data.error)
          dispatch({
            type: 'helper/show',
            payload: {
              type: 'error',
              message: 'Invalid Credentials',
              open: true,
            },
          });
        }
      },
  }),
};

export default CheckoutPayment;